// Components
import Map, { FullscreenControl, MapProvider, NavigationControl } from 'react-map-gl'
import ControlGeocoder from './components/control-geocoder'
import HeaderEmbed from '@common/HeaderEmbed'
import Llegenda from './components/llegenda'
// Textos
import textos from './assets/textos.json'
// Estils
import 'mapbox-gl/dist/mapbox-gl.css'
import './style.scss'

export function App({ lang, preview }) {
	const MAPBOX_TOKEN = 'pk.eyJ1IjoiZGlhcmlhcmEiLCJhIjoiY2w2ZXU5bXV4MGlkczNkcW92b28yaDZhdiJ9.tvNkBuIYVXtyNMfZ0vJpwg'

	return (
		<>
			{preview && <HeaderEmbed />}
			<MapProvider>
				<div
					style={{
						overflow: 'hidden',
						borderRadius: '10px',
						border: '1px solid #000',
					}}
				>
					<Map
						id="mapa_dana"
						mapboxAccessToken={MAPBOX_TOKEN}
						initialViewState={{
							longitude: -0.468,
							latitude: 39.441,
							zoom: 10.66,
						}}
						style={{
							width: '100%',
							height: 'auto',
							aspectRatio: '1/1',
						}}
						mapStyle="mapbox://styles/diariara/cm376tilf01e801qw99aa2lal"
						attributionControl={false}
						cooperativeGestures={true}
						reuseMaps
						locale={textos[lang].mapbox}
					>
						<FullscreenControl position="bottom-right" />
						<NavigationControl showZoom showCompass={false} />
						<ControlGeocoder accessToken={MAPBOX_TOKEN} />
					</Map>
				</div>
				<Llegenda lang={lang} />
			</MapProvider>
		</>
	)
}
